var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "cash-flow-account-select" },
    [
      _c(
        "a-select",
        {
          staticClass: "cash-flow-account-select__select",
          attrs: {
            mode: "multiple",
            size: "small",
            value: _vm.value,
            "show-search": "",
            "option-filter-prop": "label",
            "option-label-prop": "label",
            placeholder: _vm.placeholder
          },
          on: {
            change: function($event) {
              return _vm.$emit("change", $event)
            },
            dropdownVisibleChange: _vm.onDropdownOpen
          }
        },
        [
          _vm._l(_vm.selectedOptions, function(opt) {
            return _c(
              "a-select-option",
              { key: opt.id, attrs: { value: opt.id, label: opt.label } },
              [_vm._v(" " + _vm._s(opt.label) + " ")]
            )
          }),
          _vm.optionsMounted
            ? _vm._l(_vm.unselectedOptions, function(opt) {
                return _c(
                  "a-select-option",
                  { key: opt.id, attrs: { value: opt.id, label: opt.label } },
                  [_vm._v(" " + _vm._s(opt.label) + " ")]
                )
              })
            : _vm._e()
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }